const filterInitialState = {
    filteredPosts: [],
    search: "",
    author: [],
    tag: [],
    minDuration: 0,
    maxDuration: -1
}




export default filterInitialState;